"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _headerMenuModule = _interopRequireDefault(require("./headerMenu.module.css"));

var _link = _interopRequireDefault(require("../link/link"));

var _dropdownMenu = _interopRequireDefault(require("../dropdownMenu/dropdownMenu"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Hook
function useOnClickOutside(ref, handler) {
  (0, _react.useEffect)(function () {
    var listener = function listener(event) {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}

var DropdownLink = function DropdownLink(props) {
  var id = props.id,
      label = props.label,
      options = props.options;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDisplayed = _useState2[0],
      setIsDisplayed = _useState2[1];

  var ref = (0, _react.useRef)();
  useOnClickOutside(ref, function () {
    setIsDisplayed(false);
  });

  var toggleDisplayedState = function toggleDisplayedState(evt, clickedOutside) {
    setIsDisplayed(!isDisplayed);
  };

  if (options) {
    return _react.default.createElement("li", {
      id: id ? id : null,
      ref: ref
    }, _react.default.createElement(_link.default, {
      id: id ? "".concat(id, "_link") : null,
      expandable: true,
      expanded: isDisplayed,
      onClick: toggleDisplayedState,
      variant: "dropdown",
      arrowDirection: "right",
      label: label
    }), isDisplayed && _react.default.createElement("div", {
      id: id ? "".concat(id, "_menu_wrapper") : null
    }, _react.default.createElement(_dropdownMenu.default, {
      id: id ? "".concat(id, "_menu") : null,
      options: options
    })));
  }

  return _react.default.createElement("li", {
    id: id ? id : null
  }, _react.default.createElement(_link.default, {
    id: id ? "".concat(id, "_link") : null,
    variant: "dropdown",
    label: label
  }));
};

var HeaderMenu = function HeaderMenu(props) {
  var id = props.id,
      menuItems = props.menuItems;
  return _react.default.createElement("ul", {
    id: id ? id : null,
    className: (0, _classnames.default)(_headerMenuModule.default['nav'], _headerMenuModule.default['navbar-nav'])
  }, menuItems.map(function (menuItem) {
    return _react.default.createElement(DropdownLink, {
      id: id ? "".concat(id, "_item_").concat(menuItem.key) : null,
      key: menuItem.key,
      label: menuItem.label,
      options: menuItem.options
    });
  }));
};

HeaderMenu.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** the menu options array of objects. Each one must have  a label, a key, and an options array similar to
   * Dropdown Menu comp */
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    options: _propTypes.default.array,
    label: _propTypes.default.string,
    key: _propTypes.default.string
  })).isRequired
};
var _default = HeaderMenu;
exports.default = _default;